/**
 * Web3认证相关的工具函数
 */

/**
 * 获取启用的Web3钱包类型
 * @returns {Object} 包含各种钱包类型是否启用的对象
 */
export const getEnabledWalletTypes = () => {
  const walletTypes = import.meta.env.VITE_WALLET_TYPES || '';
  const types = walletTypes.split(',').map(t => t.trim().toLowerCase());
  
  return {
    ethereum: types.includes('ethereum'),
    solana: types.includes('solana'),
  };
};

/**
 * 检查特定钱包类型是否启用
 * @param {('ethereum'|'solana')} type 要检查的钱包类型
 * @returns {boolean} 如果钱包类型已启用，则为true，否则为false
 */
export const isWalletTypeEnabled = (type) => {
  const enabledTypes = getEnabledWalletTypes();
  return enabledTypes[type];
};

/**
 * 检查是否启用了Web3功能
 * @returns {boolean} 如果启用了Web3功能，则为true，否则为false
 */
export const isWeb3Enabled = () => {
  return import.meta.env.VITE_ENABLE_WEB3 === 'true';
};

/**
 * 格式化钱包地址，显示前几位和后几位
 * @param {string} address 钱包地址
 * @param {number} prefixLength 前缀长度
 * @param {number} suffixLength 后缀长度
 * @returns {string} 格式化后的地址
 */
export const formatWalletAddress = (address, prefixLength = 6, suffixLength = 4) => {
  if (!address) return '';
  if (address.length <= prefixLength + suffixLength) return address;
  
  return `${address.substring(0, prefixLength)}...${address.substring(address.length - suffixLength)}`;
};

/**
 * 获取钱包类型的显示名称
 * @param {string} type 钱包类型
 * @returns {string} 显示名称
 */
export const getWalletTypeDisplayName = (type) => {
  const displayNames = {
    ethereum: '以太坊',
    solana: 'Solana',
  };
  
  return displayNames[type] || type;
};

/**
 * 兼容函数：检查特定认证提供商是否启用
 * 为了兼容旧代码，将认证提供商映射到钱包类型
 * @param {string} provider 认证提供商
 * @returns {boolean} 如果启用，则为true，否则为false
 */
export const isAuthProviderEnabled = (provider) => {
  // 将旧的认证提供商映射到新的钱包类型
  if (provider === 'email') {
    // 如果启用了任何钱包类型，就认为启用了email
    return isWeb3Enabled() && (isWalletTypeEnabled('ethereum') || isWalletTypeEnabled('solana'));
  }
  
  if (provider === 'github' || provider === 'google' || provider === 'twitter' || provider === 'discord') {
    // 不再支持这些第三方认证提供商
    return false;
  }
  
  // 默认情况下返回false
  return false;
};
